module.exports = __webpack_public_path__ + "teqbahn-assets/media/de_gray.32ab6297.png";